// extracted by mini-css-extract-plugin
export default {"topButton":"ScrollToTopButton_topButton__nu86n"};